/*

    Module: jv.common.timeseries.directive
    Directive: jv-timeseries

    Usage:
        <div jv-timeseries></div>

    Data:
        [
            {
                label:
            }
        ]
 */

angular.module('jv.common.timeseries.directive', ['chart.js'])
.directive('jvTimeseries', [
    function() {
        var options = {
            responsive: true,
            animationEasing: 'easeOutCirc',
            animationSteps: 30
        };
        // have to put css colors in here
        // TODO: find a way to read them from css
        var colors = [
            '#3d87cf',
            '#e51414',
            '#f57d21',
            '#7354bd',
            '#3d87cf',
            '#38b24a',
            '#f01978',
            '#b8d3ed',
            '#f9b683',
            '#f679b0',
            '#cdc2e8'
        ];

        var pastelColors = [
            '#3d87cf',
            '#f57d21',
            '#38b24a',
            '#f9b683',
            '#f679b0',
            '#cdc2e8'
        ];
        return {
            scope: {
                timeseriesSubtitle: '@',
                timeseriesData: '=timeseriesValues',
            },
            link: function(scope, element, attrs) {
                var offset = 0;
                var chart;

                scope.labels = [];
                scope.data = [];

                var data = [];
                scope.timeseriesData.forEach(function(piece, index) {
                    scope.labels.push(piece.value);
                    data.push(piece.count);
                });

                scope.data.push(data);

                scope.options = angular.copy(options);
                scope.colors = angular.copy(colors);

                scope.handleClick = function() {
                    chart.render();
                }
                scope.$on('create', function(event, c) {
                    chart = c;
                });
            },
            // TODO: find better place for this
            //template: '<div class="jv-doughnut"><div class="jv-doughnut-chart"><div class="jv-bubble-container"><div jv-bubble bubble-title="{{ total }}" bubble-subtitle="{{ doughnutSubtitle }}"></div></div><canvas chart-doughnut chart-data="data" chart-labels="labels" chart-options="options" chart-colours="colors" chart-click="handleClick" width="150%"></canvas></div><ul class="jv-doughnut-chart-legend"><li ng-repeat="label in labels"><span class="jv-doughnut-chart-legend-circle" style="background-color: {{ colors[$index] }}"></span> <strong>{{ label }}</strong> - {{ data[$index] }}</li></ul></div>'
            template: '<div class="jv-timeseries"><canvas chart-line chart-data="data" chart-labels="labels" chart-options="options" chart-colours="colors" chart-click="handleClick" height="100%"></canvas></div>'
        }
    }
])
